export default __webpack_public_path__ + "static/media/loanpal_pro_background_smile.2a445a6c.png";